<ng-container *transloco="let t;">
  <div class="card-header">
    <h4 class="card-title font-medium-1">{{ t('Last signed documents (Dashboard last signed documents widget title) - Last signed documents') }}</h4>
  </div>
  <div class="card-body">
    @for(signedDocument of (fetchLastSignedDocuments$ | async); track signedDocument){
    <div class="transaction-item">
      <div class="media align-items-center">
        <div class="avatar bg-light-primary rounded">
          <div class="avatar-content">
            <i class="feather font-medium-3 icon-file-text"></i>
          </div>
        </div>
        <div class="media-body">
          <h6 class="transaction-title activity-Links-h6"><a class="activity-Links" [routerLink]="['/documents']" [state]="{query:signedDocument.document_number,document_id:signedDocument.id}">{{signedDocument.name}}</a></h6>
          <p class="text-muted mb-0 font-small-3">{{ signedDocument?.document_type?.document_type }}</p>
        </div>
      </div>
      <div><small class="text-muted">{{ signedDocument.updated_at | dateConversationPipe | async }}</small></div>
    </div>
    } @empty {
    <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
      <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
    </div>
    }
  </div>
</ng-container>